export enum configFeatureFlags {
  noContractSearch,
  pool,
  handover,
  exceptionTourencode,
  regionRemoval,
}
